<template>
	<div>
		<div class="upper">
			<el-row :gutter="5">
				<el-col :xs="0" :sm="4" :md="4" :lg="4" :xl="4" :offset="2">
					<div class="grid-content left">
						<div class="minibanner">
							<el-carousel :interval="6000" arrow="never" height="231px" v-if="bannerTop.length != 0">
								<el-carousel-item v-for="item in bannerTop" :key="item.Id">
									<el-image :src="domain + item.image" fit='fill' style='width:100%;height:100%'></el-image>
								</el-carousel-item>
							</el-carousel>
						</div>

						<div class="caigou" style="margin-top: 10px;">
							<el-card class="box-card">
								<div slot="header" class="clearfix">
									<span>采购中心</span>
									<el-button style="float: right; padding: 3px 0" type="text" @click="jumpNews(3)">更多>></el-button>
								</div>
								<div v-for="c in caigoulist.slice(0,6)" :key="c.Id" class="text item" @click="handleNews(c.Id)">
									{{c.title.substring(0,6)}}... <span style="float: right;">{{$utils.timestampToTimes(c.createtime*1000)}}</span>
								</div>
							</el-card>
						</div>
					</div>
				</el-col>
				<el-col :xs="0" :sm="12" :md="12" :lg="12" :xl="12">
					<div class="grid-content middle">
						<el-card class="box-card">
							<div slot="header" class="clearfix">
								<span>招标公告</span>
								<el-button style="float: right; padding: 3px 0" type="text" @click="jump(2)">更多>></el-button>
							</div>
							<div v-for="z in zhaobiaolist.slice(0,12)" :key="z.Id" class="text item" @click="handle(z.Id)">
								{{z.title.substring(0,30)}} <span style="float: right;">{{$utils.timestampToTimes(z.createtime*1000)}}</span>
							</div>
						</el-card>						
					</div>
				</el-col>
				<el-col :xs="0" :sm="4" :md="4" :lg="4" :xl="4">
					<div class="userCenter">
						<div style="width: 100%;height:37px;background-color: #409EFF;color:#fff;margin-bottom: 5px;line-height: 37px;text-align: center;">会员登录注册</div>
						<el-form ref="form" :model="sizeForm" size="small">
							<el-form-item>
								<el-input v-model="sizeForm.username" prefix-icon="el-icon-user" placeholder="请输入账号"></el-input>
							</el-form-item>
							<el-form-item>
								<el-input type="password" v-model="sizeForm.password" prefix-icon="el-icon-lock" placeholder="请输入密码"></el-input>
							</el-form-item>
<!-- 							<el-form-item>
								<el-input v-model="sizeForm.name" prefix-icon="el-icon-circle-check" placeholder="请输入验证码" style="width:62%;margin-right: 3%;"></el-input>
								<img src="http://43.138.172.5:999/captcha.html" width="100" height="25" style="vertical-align: middle;" onclick="this.src = '/captcha.html?r=' + Math.random();">
							</el-form-item> -->
							<el-form-item size="small" style="text-align: center;">
								<el-button type="primary" @click="onSubmit('sizeForm')">登录</el-button>
								<el-button @click="$router.push('/register')">注册</el-button>
							</el-form-item>
						</el-form> 
					</div>
					<div class="newMember">
						<div style="width: 100%;height:37px;background-color: #409EFF;color:#fff;margin-bottom: 5px;line-height: 37px;text-align: center;">最新注册会员</div>
						<el-card class="box-card">
						  <div v-for="m in memberlist.slice(0,7)" :key="m.id" class="text item" style="max-width: 250rpx;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">
							{{m.company}}
						  </div>
						</el-card>	
					</div>
				</el-col>
			</el-row>

		<el-row>
			<div class="center">
				<el-col :xs="0" :sm="20" :md="20" :lg="20" :xl="20" :push="2">
					<div class="smallBanner">
						  <el-carousel :interval="7000" arrow="none" height="366px">
								<el-carousel-item v-for="item in bannerMiddle" :key="item.Id">
									<el-image :src="domain + item.image" fit='fill' style='width:100%;height:100%'></el-image>
								</el-carousel-item>
						  </el-carousel>
					</div>
				</el-col>
			</div>
		</el-row>
		
		
		<el-row :gutter="10">
			<div class="below">
				<el-col :xs="0" :sm="4" :md="4" :lg="4" :xl="4" :offset="2">
					<div class="grid-content" style="text-align: center;">
						<el-carousel :interval="7500" arrow="never" height="251px">
							<el-carousel-item v-for="item in bannerBottom" :key="item.Id">
								<el-image :src="domain + item.image" fit='fill' style='width:100%;height:100%'></el-image>
							</el-carousel-item>
						</el-carousel>	
					</div>
				</el-col>
				<el-col :xs="0" :sm="12" :md="12" :lg="12" :xl="12">
					<div class="grid-content">
						<el-card class="box-card">
						  <div slot="header" class="clearfix">
						    <span>招投标常识</span>
						    <el-button style="float: right; padding: 3px 0" type="text" @click="jumpNews(5)">更多</el-button>
						  </div>
						<div v-for="c in ztbcslist.slice(0,4)" :key="c.Id" class="text item" @click="handleNews(c.Id)">
							{{c.title.substring(0,30)}} <span style="float: right;">{{$utils.timestampToTimes(c.createtime*1000)}}</span>
						</div>
						</el-card>
					</div>
				</el-col>
				<el-col :xs="0" :sm="4" :md="4" :lg="4" :xl="4">
					<div class="grid-content">
						<el-card class="box-card">
						  <div slot="header" class="clearfix">
						    <span>物流常识</span>
						    <el-button style="float: right; padding: 3px 0" type="text" @click="jumpNews(6)">更多</el-button>
						  </div>
						<div v-for="c in wlzxlist.slice(0,4)" :key="c.Id" class="text item" @click="handleNews(c.Id)">
							{{c.title.substring(0,6)}} <span style="float: right;">{{$utils.timestampToTimes(c.createtime*1000)}}</span>
						</div>
						</el-card>
					</div>
				</el-col>
			</div>
		</el-row>
		</div>
		<!-- 手机端 -->
		<el-row>
			<el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0" >
				<div class="nav">
					<div class="nav-item" @click="$router.push('/')">
						<div class="item-icon" style="background-color: #409EFF;"><i class="el-icon-s-home" style="font-size: 3rem;color:#fff;line-height: 60px;"></i></div>
						<div class="item-text">首页</div>
					</div>
					<div class="nav-item" @click="jump(2)">
						<div class="item-icon" style="background-color: #ff5500;"><i class="el-icon-s-operation" style="font-size: 3rem;color:#fff;line-height: 60px;"></i></div>
						<div class="item-text">招标公告</div>
					</div>
					<div class="nav-item" @click="jump(4)">
						<div class="item-icon" style="background-color: #55ff7f;"><i class="el-icon-s-order" style="font-size: 3rem;color:#fff;line-height: 60px;"></i></div>
						<div class="item-text">散单需求</div>
					</div>
					<div class="nav-item" @click="$router.push('/member')">
						<div class="item-icon" style="background-color: #55ffff;"><i class="el-icon-user-solid" style="font-size: 3rem;color:#fff;line-height: 60px;"></i></div>
						<div class="item-text">会员推荐</div>
					</div>
				</div>
				<div class="mobile-zhaobiao">
<!-- 					<el-card class="box-card">
						<div slot="header" class="clearfix">
							<span>最新招标</span>
							<el-button style="float: right; padding: 3px 0" type="text" @click="jump('3')">更多>></el-button>
						</div>
						<div v-for="z in zhaobiaolist.slice(0,10)" :key="z.Id" class="text item" @click="handle(z.Id)">
							{{z.title.substring(0,12)}}<span style="float: right;">{{$utils.timestampToTimes(z.createtime*1000)}}</span>
						</div>
					</el-card>	 -->
					<div style="margin:10px auto; text-align: center; font-size: 1.5rem;font-weight: bold;color: #304999;">全国物流运输招标服务平台</div>
					<div style="margin:10px auto; text-align: center; font-size: 0.8rem;color: rgb(145,145,145);">专注物流运输招标，采购信息免费查看</div>
				</div>
				<div class="release">
					<el-button type="primary" style="border-radius:30px;background-color: #00A0E8;border-color: #00A0E8;" @click="$router.push('/release')"><span style="font-size: 1rem;">发布招标信息</span><span style="font-weight: bold;padding: 0 10px;">></span></el-button>
				</div>
			</el-col>
			<div class="mobile-banner" style="margin:0 -20px">
				<el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0">
					<el-carousel :interval="5000" height="126px" arrow="never">
						<el-carousel-item v-for="item in bannerMiddle" :key="item.Id">
						  <el-image :src="domain + item.image" fit='fill' style='width:100%;height:126px'></el-image>
						</el-carousel-item>
					</el-carousel>
				</el-col>
			</div>
			<el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0">
			<div class="nav" style="margin:20px auto;margin-bottom: 30px;">
				<div class="nav-item" @click="$router.push('/newslist/id/3')" style="text-align: center;">
					<div class="item-icon" style="background-color: #ff5500;"><i class="el-icon-shopping-cart-full" style="font-size: 3rem;color:#fff;line-height: 60px;"></i></div>
					<div class="item-text">采购中心</div>
				</div>
				<div class="nav-item" @click="$router.push('/newslist/id/5')">
					<div class="item-icon" style="background-color: #55ff7f;margin:0 auto"><img src="/images/ztbcs-icon.jpg" alt=""></div>
					<div class="item-text">招投标常识</div>
				</div>
				<div class="nav-item" @click="$router.push('/newslist/id/6')">
					<div class="item-icon" style="background-color: #55ffff;"><i class="el-icon-document" style="font-size: 3rem;color:#fff;line-height: 60px;"></i></div>
					<div class="item-text">物流常识</div>
				</div>
			</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		// name:'main',
		metaInfo() {
		  return {
			title: this.metaName,
			meta: [{ charset: "utf-8",
			},{ 
				name: "keywords", 
			    content: this.metaKeywords,
			},{ 
				name: "description", 
			    content: this.metaDecs,
			  }],
		  }
		},
		data() {
		  return {
			bannerTop:[],
			bannerMiddle:[],
			bannerBottom:[],
			zhaobiaolist:[],
			caigoulist:[],
			ztbcslist:[],
			wlzxlist:[],
			memberlist:[],
			domain:this.$utils.httpUrl,
			metaName: "",
			metaKeywords: "",
			metaDecs: "",
			userInfo:{},
			sizeForm: {
			  username: '',
			  password: ''
			}
		  };
		},
		created() {
			this.$axios({
				url:this.$utils.httpApi + 'index/webconfig'
			}).then(res=>{
				this.metaName = res.data.data.webtitle
				this.metaDecs = res.data.data.webdescription
				this.metaKeywords = res.data.data.webkeywords
			}),
			this.getBanners();
			this.getZhaobiao();
			this.getCaigou();
			this.getNewMember()
		},
		methods: {
		  getZhaobiao(){
			this.$axios({
				url:this.$utils.httpApi + 'index/getIndexZhaobiao'
			}).then(res=>{
				res.data.data.forEach(resp=>{
					if(resp.typelist == 0){
						this.zhaobiaolist.push(resp)
						
					}
				})
			})   
		  },
		  getCaigou(){
			this.$axios({
				url:this.$utils.httpApi + 'index/getIndexCaigou'
			}).then(res=>{
				res.data.data.forEach(resp=>{
					if(resp.typelist == 0){
						this.caigoulist.push(resp)
					}else if(resp.typelist == 1){
						this.ztbcslist.push(resp)
					}else if(resp.typelist == 2){
						this.wlzxlist.push(resp)
					}
				})
			})   
		  },
		  getNewMember(){
			this.$axios({
				url:this.$utils.httpApi + 'index/getNewMember'
			}).then(res=>{
				res.data.data.forEach(resp=>{
					this.memberlist = res.data.data
				})
			})   
		  },
		  getBanners(){
			this.$axios({
				url:this.$utils.httpApi + 'index/getBanner'
			}).then(res=>{
				res.data.data.forEach(resp=>{
					if(resp.type == 1){
						this.bannerTop.push(resp)
					}else if(resp.type == 2){
						this.bannerMiddle.push(resp)
					}else if(resp.type == 3){
						this.bannerBottom.push(resp)
					}
				})
			}) 
		  },
		  onSubmit() {
			this.$axios({
				method:'post',
				url:this.$utils.httpApi + 'user/login',
				data:this.sizeForm
			}).then(res=>{
				if(res.data.code == 1){
					window.localStorage.setItem('token',res.data.data.userinfo.token)
					this.$message.success(res.data.msg)
					window.location.reload()
					
				}else{
					this.$message.error(res.data.msg)
					
				}
			})
		  },
		  handle(id){
			  // this.$router.push('details/id/'+id)
			   // this.$router.push({path: 'details/id/', query: { id: id }})
			   const url = 'details/id/'+id
			   window.open(url, '_blank')
		  },
		  handleNews(id){
			  // this.$router.push('newsdetails/id/'+id)
			  const url = 'newsdetails/id/'+id
			  window.open(url, '_blank')
		  },
		  jump(id){
			  // this.$router.push('list/id/'+id)
			  let url = null
			  if(id == 2){
				url = 'list'
			  }else if(id == 4){
				url = 'sandan'
			  }
			  // const url = 'list/id/'+id
			  window.open(url, '_blank')
		  },
		  jumpNews(id){
			  // this.$router.push('newslist/id/'+id)
			  const url = 'newslist/id/'+id
			  window.open(url, '_blank')
		  }
		}
	};
</script>

<style scoped>
	.nav{
		display: flex;
		justify-content: space-between;
	}
	.nav-item{
		text-align: center;
	}
	.item-icon{
		border-radius: 5px;
		width:60px;
		height:60px;
	}
	.item-text{
		margin-top: 10px;
	}
	.mobile-zhaobiao{
		margin-top: 16px;
		width:100%;
		margin-bottom: 10px;
	}
	.release{
		margin-bottom: 10px;
		text-align: center;
	}
	.el-col {
	border-radius: 4px;
	}
	.bg-purple-dark {
	background: #99a9bf;
	}
	.bg-purple {
	background: #d3dce6;
	}
	.bg-purple-light {
	background: #e5e9f2;
	}
	.grid-content {
	border-radius: 4px;
	min-height: 36px;
	}
	.el-carousel__item h3 {
	color: #475669;
	font-size: 18px;
	opacity: 0.75;
	line-height: 270px;
	margin: 0;
	}
	.text {
	font-size: 14px;
	cursor: pointer;
	}

	.item {
	margin-bottom: 18px;
	max-width: ;
	}

	.clearfix:before,
	.clearfix:after {
	display: table;
	content: "";
	}
	.clearfix:after {
	clear: both
	}
	.left{

	}
	.caigou {
		
	}
	.item{
		border-bottom: #e5e9f2 dashed 1px;
		margin-bottom: 0!important;
		height:40px;
		line-height: 40px;
	}
	.box-card{
		border:#DCDFE6 solid 1px;
	}
	.el-card ::v-deep .el-card__header{
		border:1px solid #409EFF!important;
		height: 40px;
		padding:10px!important;
	}
	.el-card ::v-deep .el-card__header span{
		color:#409EFF;
	}
	.el-carousel__item h3 {
		color: #475669;
		font-size: 18px;
		opacity: 0.75;
		line-height: 200px;
		margin: 0;
	}

	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n+1) {
		background-color: #d3dce6;
	}
	.minibanner{
		text-align: center;
	}
	.smallBanner{
		margin-top: 10px;
		text-align: center;
	}
	.below{
		margin-top: 10px;
	}
</style>